export const worksList = [
  {
    id: "w1",
    title: "无声告白",
    type: "电影",
    year: 2023,
    director: "陈屿",
    cast: ["筱田优", "林澈", "苏晚"],
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20film%20poster%20style%20portrait%20of%20a%20young%20woman%20in%20soft%20shadowed%20profile%2C%20deep%20indigo%20background%20with%20a%20single%20warm%20amber%20rim%20light%2C%20quiet%20and%20emotional%2C%20cinematic%20editorial%20photography&width=800&height=1200&seq=work-c01&orientation=portrait",
    synopsis:
      "一场意外之后，沉默成了她与世界之间唯一的连接。当尘封的记忆被一点点揭开，她必须在真相与自我之间做出选择。影片以克制的镜头语言，讲述了一个关于告别与和解的故事。",
    tags: ["剧情", "悬疑", "获奖"],
    popularity: 92,
    rating: 8.6,
    relatedNewsIds: ["n4", "n7"],
  },
  {
    id: "w2",
    title: "雾中来信",
    type: "电影",
    year: 2022,
    director: "周镜",
    cast: ["筱田优", "苏晚"],
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20portrait%20of%20a%20woman%20silhouette%20in%20morning%20fog%2C%20soft%20grey%20indigo%20haze%20with%20faint%20warm%20light%2C%20poetic%20and%20literary%20mood%2C%20minimal%20art%20house%20film%20poster%20style&width=800&height=1200&seq=work-c02&orientation=portrait",
    synopsis:
      "一封没有署名的信，把小城里的两个人重新拉回彼此的生活。影片以诗意的影像，描摹了一段被时间稀释却未曾消失的情感。",
    tags: ["文艺", "剧情", "情感"],
    popularity: 78,
    rating: 8.1,
    relatedNewsIds: ["n7"],
  },
  {
    id: "w3",
    title: "长夜将尽",
    type: "电影",
    year: 2024,
    director: "陈屿",
    cast: ["筱田优", "江野", "林澈"],
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20portrait%20of%20a%20determined%20woman%20against%20a%20rainy%20city%20night%2C%20deep%20indigo%20and%20teal%20shadows%20with%20warm%20neon%20reflections%2C%20tense%20crime%20thriller%20poster%20style&width=800&height=1200&seq=work-c03&orientation=portrait",
    synopsis:
      "长夜之下，真相从不明亮。她穿梭在谎言与记忆的裂缝里，一步步逼近被掩盖的事实。这部犯罪悬疑片用冷峻的影像与紧绷的节奏，探讨了人在极端处境下的选择。",
    tags: ["犯罪", "悬疑", "剧情"],
    popularity: 96,
    rating: 8.9,
    relatedNewsIds: ["n1", "n3"],
  },
  {
    id: "w4",
    title: "春山可望",
    type: "电视剧",
    year: 2023,
    director: "李青禾",
    cast: ["筱田优", "温屿", "顾清和"],
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20period%20drama%20portrait%20of%20a%20woman%20in%20a%20gentle%20sunlit%20countryside%20setting%2C%20warm%20amber%20and%20soft%20green%20tones%2C%20delicate%20film%20grain%2C%20elegant%20retro%20poster%20style&width=800&height=1200&seq=work-c04&orientation=portrait",
    synopsis:
      "跨越数十年的岁月里，一个普通女性在时代变迁中守护着自己的家庭与信念。剧集以细腻的笔触，描绘了时间如何改变一切，又如何留下最珍贵的东西。",
    tags: ["年代", "家庭", "口碑"],
    popularity: 88,
    rating: 8.4,
    episodes: 24,
    relatedNewsIds: ["n5", "n3"],
  },
  {
    id: "w5",
    title: "深海回响",
    type: "电影",
    year: 2021,
    director: "顾承",
    cast: ["筱田优", "叶知秋"],
    cover:
      "https://readdy.ai/api/search-image?query=Surreal%20underwater%20portrait%20of%20a%20floating%20figure%20surrounded%20by%20soft%20light%20rays%20and%20bubbles%2C%20deep%20indigo%20and%20teal%20ocean%20world%2C%20dreamlike%20and%20serene%2C%20artistic%20sci-fi%20poster%20style&width=800&height=1200&seq=work-c05&orientation=portrait",
    synopsis:
      "深海中传来的一段回声，唤醒了她对过往的全部记忆。影片以海洋为舞台，讲述了一个关于记忆、失去与重新出发的故事。",
    tags: ["科幻", "剧情", "文艺"],
    popularity: 70,
    rating: 7.9,
    relatedNewsIds: ["n8"],
  },
  {
    id: "w6",
    title: "归途列车",
    type: "电视剧",
    year: 2022,
    director: "沈牧",
    cast: ["筱田优", "顾清和", "温屿"],
    cover:
      "https://readdy.ai/api/search-image?query=Reflective%20portrait%20of%20a%20woman%20looking%20out%20of%20a%20train%20window%20at%20dusk%2C%20warm%20amber%20sunset%20light%20on%20her%20face%2C%20soft%20blur%20of%20passing%20landscape%2C%20nostalgic%20cinematic%20poster&width=800&height=1200&seq=work-c06&orientation=portrait",
    synopsis:
      "在一趟又一趟往返的列车上，她遇见了形形色色的人，也一点点找回了自己。都市情感剧《归途列车》用旅途串起了普通人的悲欢。",
    tags: ["都市", "情感", "治愈"],
    popularity: 82,
    rating: 8.2,
    episodes: 36,
    relatedNewsIds: ["n9"],
  },
  {
    id: "w7",
    title: "光年之外",
    type: "电影",
    year: 2025,
    director: "陈屿",
    cast: ["筱田优", "林澈"],
    cover:
      "https://readdy.ai/api/search-image?query=Poetic%20sci-fi%20poster%20of%20a%20lone%20figure%20gazing%20at%20a%20vast%20nebula%2C%20deep%20indigo%20space%20with%20soft%20amber%20and%20violet%20highlights%2C%20minimal%20and%20epic%2C%20cinematic%20wide%20portrait&width=800&height=1200&seq=work-c07&orientation=portrait",
    synopsis:
      "在光年之外的旅途中，孤独是最长的一段距离。两个因使命相遇的人，在浩瀚星海中彼此照亮。影片以极具想象力的视觉建构，讲述了一个关于陪伴与勇气的故事。",
    tags: ["科幻", "冒险", "新片"],
    popularity: 99,
    rating: 9.1,
    relatedNewsIds: ["n2", "n10"],
  },
  {
    id: "w8",
    title: "逆风局",
    type: "电视剧",
    year: 2024,
    director: "苏黎",
    cast: ["筱田优", "江野"],
    cover:
      "https://readdy.ai/api/search-image?query=Confident%20professional%20portrait%20of%20a%20woman%20in%20a%20modern%20office%2C%20soft%20daylight%20through%20large%20windows%2C%20clean%20neutral%20indigo%20and%20grey%20palette%2C%20elegant%20workplace%20drama%20poster%20style&width=800&height=1200&seq=work-c08&orientation=portrait",
    synopsis:
      "当一切看似都与她作对，她仍选择迎难而上。都市职场剧《逆风局》聚焦职场中的选择与坚持，讲述了一群年轻人如何在压力之下找到自己的方向。",
    tags: ["职场", "励志", "都市"],
    popularity: 90,
    rating: 8.5,
    episodes: 30,
    relatedNewsIds: ["n6"],
  },
  {
    id: "w9",
    title: "白昼流星",
    type: "电影",
    year: 2020,
    director: "周镜",
    cast: ["筱田优", "苏晚"],
    cover:
      "https://readdy.ai/api/search-image?query=Gentle%20literary%20portrait%20of%20a%20woman%20in%20soft%20morning%20light%2C%20pale%20indigo%20and%20warm%20cream%20tones%2C%20dreamy%20and%20tender%20mood%2C%20minimal%20romantic%20film%20poster%20style&width=800&height=1200&seq=work-c09&orientation=portrait",
    synopsis:
      "有些相遇如同白昼里的流星，短暂却照亮了整段青春。影片以温柔的笔触，记录了一段关于成长与错过的故事。",
    tags: ["文艺", "爱情", "青春"],
    popularity: 65,
    rating: 7.6,
    relatedNewsIds: ["n4"],
  },
];